"use strict";

contractService.$inject = ["$http", "api", "Contract", "ContractDetail"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contractService = contractService;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function contractService($http, api, Contract, ContractDetail) {

    return {
        get: get,
        getById: getById,
        getNumberOfContracts: getNumberOfContracts
    };

    function get() {
        return api.contracts.list().$promise.then(function (response) {
            return _lodash2.default.map(response, function (i) {
                return _lodash2.default.assign({
                    "type": i.portalContractType,
                    "contracts": _lodash2.default.map(i.contracts, function (x) {
                        return Contract.create(x);
                    })
                });
            });
        });
    }

    function getById(id) {
        return api.contractDetail.get({ id: id }).$promise.then(function (response) {
            return ContractDetail.create(response);
        });
    }
    function getNumberOfContracts(sellerId) {
        return api.numberOfContracts.get({ sellerId: sellerId }).$promise.then(function (response) {
            return response.amount;
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/contractService.js
// module id = 807
// module chunks = 0